// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_Enf","cls2":"FocusedNav-cls2_Ckw FocusedNav-cls1_Enf"};